import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {CleaningActivitiesColumnModel} from '../../../../model/creationCleaningActivities.model'
import {CREATION_CLEANING_ACTIVITIES_SERVICES} from '../../../../services/creation-cleaning-activities.service'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  cleaningActivity: CleaningActivitiesColumnModel
}

export const ModalViewQR: FC<Props> = ({show, setShow, cleaningActivity}) => {
  const [qrUrl, setQrUrl] = useState<string | null>(null)

  const handleClose = () => {
    setShow(false)
  }

  const handleGetQr = async () => {
    try {
      const response = await CREATION_CLEANING_ACTIVITIES_SERVICES.getQrActivityById(
        cleaningActivity.Id!,
      )
      const blob = new Blob([response.data], {type: 'application/pdf'})

      const url = URL.createObjectURL(blob)
      setQrUrl(url)
    } catch (error) {}
  }

  useEffect(() => {
    if (show && cleaningActivity) {
      handleGetQr()
    }
  }, [cleaningActivity, show])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Código QR</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='flex justify-center items-center' style={{height: '80vh'}}>
            <iframe src={qrUrl} style={{width: '100%', height: '100%'}} />
          </div>
        </div>
      </div>
    </Modal>
  )
}
